export const sortByAsc = (f: (x: any) => any) => {
	return (a: any, b: any) => {
		if (f(a) < f(b)) { return -1; }
		if (f(a) > f(b)) { return 1; }
		return 0;
	};
};

export const sortByDesc = (f: (x: any) => any) => {
	return (a: any, b: any) => {
		if (f(a) < f(b)) { return 1; }
		if (f(a) > f(b)) { return -1; }
		return 0;
	};
};